const defaultLocale = () => {
  if (typeof navigator !== 'undefined' && navigator.language) {
    return navigator.language
  }
  return 'en-US'
}

// Normalise common non-ISO currency names/strings to ISO 4217 codes.
// LLMs often return currency as words (евро, euro, dollars) or symbols ($, €).
const CURRENCY_ALIASES = {
  евро: 'EUR', euro: 'EUR', eur: 'EUR', euros: 'EUR',
  доллар: 'USD', dollar: 'USD', usd: 'USD', dollars: 'USD',
  фунт: 'GBP', pound: 'GBP', gbp: 'GBP', pounds: 'GBP',
  '₽': 'RUB', рубль: 'RUB', руб: 'RUB', rouble: 'RUB', rub: 'RUB',
  '€': 'EUR', '£': 'GBP', '$': 'USD', '¥': 'JPY',
}

function normalizeCurrency(raw) {
  if (!raw || typeof raw !== 'string') return null
  const trimmed = raw.trim().toLowerCase()
  return CURRENCY_ALIASES[trimmed] || null
}

export function formatCurrency(amount, currency = 'EUR', locale = defaultLocale()) {
  if (amount === null || amount === undefined || amount === '') {
    return '-'
  }

  const numeric = typeof amount === 'string' ? Number(amount.replace(/[^0-9.-]+/g, '')) : Number(amount)
  if (Number.isNaN(numeric)) {
    return String(amount)
  }

  let currencyCode = typeof currency === 'string' ? currency.toUpperCase() : 'EUR'
  const alias = normalizeCurrency(currencyCode)
  if (alias) currencyCode = alias

  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(numeric)
  } catch (error) {
    return `${numeric.toFixed(2)} ${currencyCode}`
  }
}
